import React, { forwardRef, useEffect } from 'react';

import { getUID } from '@atlas/core';
import { DefaultPopup } from '@atlas/ui';

import { useNotificationsUIContext } from 'common/Popup/NotificationsUIContext';

export const NotificationEmitterDefaultPopup = forwardRef((props, ref) => {
  const { children } = props;
  const { emitPopupToggle } = useNotificationsUIContext();

  useEffect(() => {
    const popupId = getUID();

    emitPopupToggle(popupId);

    return () => {
      emitPopupToggle(popupId);
    };
  }, []);

  return (
    <DefaultPopup {...props} ref={ref}>
      {children}
    </DefaultPopup>
  );
});
